"use strict";

exports.__esModule = true;
exports.RenderDataToComponents = void 0;
var _dataset = require("../entities/dataset");
var _schema = require("../entities/schema");
var _wixDataSchemaTypes = require("@wix/wix-data-schema-types");
const RenderDataToComponents = () => ({
  dataset,
  schema,
  connections,
  components
}) => {
  if (connections.length) {
    for (const connection of connections) {
      const propEntries = mapValuesToComponentProps(connection, dataset, schema);
      const component = components.find(comp => comp.id === connection.compId);
      if (propEntries.length) {
        component.setData(Object.fromEntries(propEntries));
      }
    }
  }
};
exports.RenderDataToComponents = RenderDataToComponents;
const mapValuesToComponentProps = (connection, dataset, schema) => {
  const componentProps = [...getDynamicProps(connection, dataset, schema), ...getBehaviorRelatedProps(connection, dataset), ...getExtraProps(connection)];
  for (const [name, connectionDescriptor] of Object.entries(connection.properties)) {
    if (connectionDescriptor.properties) {
      const nestedComponentPropEntries = mapValuesToComponentProps(connectionDescriptor, dataset, schema);
      componentProps.push([name, Object.fromEntries(nestedComponentPropEntries)]);
    } else {
      if (_dataset.Dataset.hasCurrentRecord(dataset)) {
        const {
          fieldName,
          dataType
        } = connectionDescriptor;
        const fieldValue = _dataset.Dataset.getFromCurrentRecord(dataset, fieldName);
        componentProps.push([name, convertValueByDataType({
          dataType,
          value: fieldValue,
          schema,
          fieldName
        })]);
      }
    }
  }
  return componentProps;
};
const valueConverterByDataType = {
  text: ({
    value,
    schema,
    fieldName
  }) => {
    if (value === null || value === undefined) {
      return '';
    }
    switch (_schema.Schema.getFieldType(schema, fieldName)) {
      case _wixDataSchemaTypes.FieldType.address:
        return value.formatted;
      case _wixDataSchemaTypes.FieldType.stringArray:
        return value.join(', ');
      // Default behavior or Field is unknown
      default:
        return Array.isArray(value) ? value.join(', ') : String(value);
    }
  }
};
const behaviorRelatedPropSetters = {
  input: ({
    disabled: disabledProp
  }, dataset) => _dataset.Dataset.isReadonly(dataset) ? [disabledProp, true] : [],
  click: ({
    action,
    disabled: disabledProp
  }, dataset) => action === 'next' && !_dataset.Dataset.hasNextRecord(dataset) || action === 'previous' && !_dataset.Dataset.hasPrevRecord(dataset) ? [disabledProp, true] : []
};
const dynamicPropsSetters = {
  text: ({
    dataset,
    schema,
    connectionDescriptor: {
      fieldName,
      typeMapping,
      extraData,
      propName
    }
  }) => {
    if (!_dataset.Dataset.hasCurrentRecord(dataset)) {
      return undefined;
    }
    const fieldValue = _dataset.Dataset.getFromCurrentRecord(dataset, fieldName);
    const fieldType = _schema.Schema.getFieldType(schema, fieldName);
    return [typeMapping[fieldType] ?? propName, fieldType === _wixDataSchemaTypes.FieldType.url ? `<a href="${fieldValue}" target="${(extraData == null ? void 0 : extraData.target) ?? '_blank'}"${extraData != null && extraData.rel ? ` rel="${extraData.rel}"` : ''} style="text-decoration: underline">${fieldValue}</a>` : convertValueByDataType({
      dataType: 'text',
      value: fieldValue,
      schema,
      fieldName
    })];
  },
  totalCount: ({
    dataset,
    connectionDescriptor: {
      propName
    }
  }) => {
    if (dataset.pagination.type === 'cursor') {
      return undefined;
    }
    return [propName, String(_dataset.Dataset.getTotalCount(dataset))];
  }
};
const convertValueByDataType = ({
  value,
  schema,
  fieldName,
  dataType
}) => {
  const valueConverter = valueConverterByDataType[dataType];
  if (valueConverter) {
    return valueConverter({
      value,
      schema,
      fieldName
    });
  }
  return value;
};
const getBehaviorRelatedProps = (connection, dataset) => {
  const behaviorRelatedProps = [];
  for (const [name, behaviorDescriptor] of Object.entries(connection.behaviors)) {
    const behaviorRelatedPropEntry = behaviorRelatedPropSetters[name](behaviorDescriptor, dataset);
    if (behaviorRelatedPropEntry.length) {
      behaviorRelatedProps.push(behaviorRelatedPropEntry);
    }
  }
  return behaviorRelatedProps;
};
const getDynamicProps = (connection, dataset, schema) => {
  const componentProps = [];
  if (Object.keys(connection.dynamicProperties).length) {
    for (const [name, connectionDescriptor] of Object.entries(connection.dynamicProperties)) {
      const result = dynamicPropsSetters[name]({
        dataset,
        schema,
        connectionDescriptor
      });
      if (result) {
        componentProps.push(result);
      }
    }
  }
  return componentProps;
};
const getExtraProps = connection => {
  const extraProps = [];
  for (const [name, value] of Object.entries(connection.extraData)) {
    extraProps.push([name, value]);
  }
  return extraProps;
};
//# sourceMappingURL=render-data-to-components.js.map